import { IStandingRows } from './standing';
import { RaceSessionStatus } from './race-session';
import { IDriver } from './driver';
import { ITeam } from './team';
import { IStanding } from './standing';

export type DriversStadingVariants =
  | 'total-points'
  | 'free-practice-results'
  | 'qualifying-results'
  | 'race-starting-grid'
  | 'race-results';
  
  export const DRIVERS_STANDING_TOTAL_POINTS: DriversStadingVariants = 'total-points';
  export interface IGenericDriversStanding<T> {
    readonly rankingVariant: DriversStadingVariants;
    readonly standingsList: ReadonlyArray<IStandingRows<T>>;
    readonly status?: RaceSessionStatus;
  }

  
  export interface IDriversTotalPointStandingRow extends IStanding, IDriver, ITeam {
    readonly points: string;
  }